// extracted by mini-css-extract-plugin
export var legendIndicator = "_ih-1";
export var legendRight = "_ih-0";